export default {
  // Font family
  family: {
    primary: '"HelveticaNowDisplay", Helvetica, sans-serif',
  },

  // Font weight
  weight: {
    regular: '300',
    normal: '400',
    bold: '700',
    xbold: '900',
  },

  // Line-height
  lineHeight: {
    small: '1',
    medium: '1.5',
    large: '2',
  },

  // Font Sizes
  size: {
    xxsmall: '0.5rem',
    xsmall: '0.75rem',
    small: '0.875rem',
    default: '1rem',
    medium: '1.25rem',
    xmedium: '1.5rem',
    large: '1.875rem',
    xlarge: '3rem',
    xxlarge: '4rem',
    xxxlarge: '5rem',
  },
};
